var e = e || {},
    niebuhr = {};
( function () {
    'use strict';
    jQuery( function () {
        niebuhr.init();
    } );
    niebuhr.init = function () {
        niebuhr.video.init();
    };
    niebuhr.video = {};
    niebuhr.video.init = function () {
        jQuery('.js-niebuhr-video-play').on('click', function(){
            var jIframeSrc = jQuery(this).closest('.niebuhr-video-container').find('iframe').attr('src');

            jIframeSrc = jIframeSrc + '&autoplay=1';

            jQuery(this).closest('.niebuhr-video-container').find('iframe').attr('src', jIframeSrc);
            jQuery(this).closest('.niebuhr-video-container').find('iframe').show();

            jQuery('video').closest('.niebuhr-video-container').find('video').show().trigger('play');
        });
    };
}() );
